




import { Component, mixins } from '@niknevis/vue-modules'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import { InjectReactive } from 'vue-property-decorator'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import DateTooltippedTableCell from '@/modules/shared/components/panel/DateTooltippedTableCell.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import PanelInvoiceActions from '@/modules/invoice/components/panel/table/PanelInvoiceActions.vue'
import {
  InvoiceCollectionTypeDefault,
  InvoiceCollectionWithModelDefault
} from '@/modules/invoice/models/invoice-collection.model'
import InvoicePersonTypeView from '@/modules/invoice/components/shared/InvoicePersonTypeView.vue'
import InvoiceStatusView from '@/modules/invoice/components/shared/InvoiceStatusView.vue'

@Component({
  components: { TextEllipsis, BaseButton, TesTd, TesTr }
})
export default class PanelInvoiceTableRow extends mixins<TesTableRow>(TesTableRow) {

  @InjectReactive()
  invoices!: InvoiceCollectionTypeDefault

  get fixedData(): InvoiceCollectionWithModelDefault {
    return {
      model_types: this.invoices.model_types,
      person_types: this.invoices.person_types,
      statuses: this.invoices.statuses
    }
  }

  columnComponents = {
    title: {
      component: TextEllipsis,
      handler: (value) => ({ text: value })
    },
    person_type: {
      component: InvoicePersonTypeView,
      handler: (value, row, withData) => ({ type: row.person_type, types: withData.person_types })
    },
    status: {
      component: InvoiceStatusView,
      handler: (value, row, withData) => ({ status: row.status, statuses: withData.statuses })
    },
    paid_at: DateTooltippedTableCell,
    due_date: DateTooltippedTableCell,
    actions: {
      component: PanelInvoiceActions,
      handler: (value, row, withData) => ({ invoice: row, withData: withData })
    }
  }
}
